// extracted by mini-css-extract-plugin
module.exports = {"title":"index_title__2GdsX","active":"index_active__3U722"};